import { INTERNAL_API_ROOT } from '../../config/api'
import { CALL_INTERNAL_API } from '../../middleware/authHeaders'

// TYPES & ACTIONS

export const GET_PAYMENT_BY_CORRELATION_ID_REQUEST = 'GET_PAYMENT_BY_CORRELATION_ID_REQUEST'
export const GET_PAYMENT_BY_CORRELATION_ID_SUCCESS = 'GET_PAYMENT_BY_CORRELATION_ID_SUCCESS'
export const GET_PAYMENT_BY_CORRELATION_ID_FAILURE = 'GET_PAYMENT_BY_CORRELATION_ID_FAILURE'

export const getPaymentById = id => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/payments?id=${id}`,
      types: [
        GET_PAYMENT_BY_CORRELATION_ID_REQUEST,
        GET_PAYMENT_BY_CORRELATION_ID_SUCCESS,
        GET_PAYMENT_BY_CORRELATION_ID_FAILURE,
      ],
    },
  })
}

// SELECTORS
export const selectPaymentLookup = state => {
  return state.submittable.paymentLookup.payment
}

// STATE
const INITIAL_STATE = {
  correlationIdLookup: '',
  payment: {
    paymentData: null,
    isLoading: false,
    error: false,
  },
}

// REDUCERS
const paymentLookup = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_PAYMENT_BY_CORRELATION_ID_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      payment: {
        paymentData: newPayload,
        isLoading: false,
        error: false,
      },
    }),
    [GET_PAYMENT_BY_CORRELATION_ID_REQUEST]: currentState => ({
      ...currentState,
      payment: {
        ...currentState.payment,
        isLoading: true,
        error: false,
      },
    }),
    [GET_PAYMENT_BY_CORRELATION_ID_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      payment: {
        ...currentState.payment,
        isLoading: false,
        error: {
          error: true,
          response: newPayload,
        },
      },
    }),
  }[type]?.(state, payload) || state)

export default paymentLookup
